import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import {
	Announcement,
	CommunicationEvents,
	SubscriptionStatus
} from '@models/subscription.model';
import { SNModalService } from '@web-services/modal/snModal.service';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { AlertAction, GeneralAction } from '@models/models';

@Component({
	selector: 'subscription-announcement-banner',
	template: require('./subscription-announcement-banner.html'),
	styles: [require('./subscription-announcement-banner.scss')],
	providers: [
		{
			provide: CarouselConfig,
			useValue: { interval: 60000, noPause: false, showIndicators: false }
		}
	]
})
export class SubscriptionAnnouncementBannerComponent
	implements OnInit, OnDestroy {
	announcementData: Array<Announcement>;
	actionList: Array<string> = [];
	disableButton: boolean;
	private checkoutPlanOpenEvent;
	private confirmPaymentOpenEvent;
	private billingOpenEvent;
	private updateOpenEvent;

	constructor(
		private subscriptionService: NewSubscriptionServiceDataProvider,
		private snModalService: SNModalService,
		private iframeService: IframeService,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.attachEventHandlers();
		this.getAnnouncementData();
	}

	ngOnDestroy(): void {
		this.detachEventListeners();
	}

	private loadIframe(url: string): void {
		this.disableButton = true;
		this.iframeService.setUrlIframe(url);
	}

	openNewWindow(url: string): void {
		window.open(url, '_blank');
	}

	reactToButtonClick(action: GeneralAction, actionName) {
		switch (action.method) {
			case 'NEW_WINDOW':
				return this.openNewWindow(action.url);

			case 'FRAME':
				return this.loadIframe(action.url);

			case 'ALERT_MODAL':
				return this.openAlertModal(action.alertMessage);
		}

		if (action.method === 'MANUAL' && actionName === 'CHOOSE_PLAN') {
			this.openChoosePlanModal();
		}
	}

	private openChoosePlanModal(): void {
		this.subscriptionService.setChoosePlanOpenModalStatus({
			state: true,
			payload: null
		});
	}

	attachEventHandlers(): void {
		this.onConfirmPaymentPaymentOpen();
		this.onCheckoutOpenEvent();
		this.onEditBillingModalIframeOpen();
		this.onUpdatePaymentClose();
	}

	detachEventListeners(): void {
		this.checkoutPlanOpenEvent();
		this.confirmPaymentOpenEvent();
		this.billingOpenEvent();
		this.updateOpenEvent();
	}

	private getAnnouncementData(): void {
		this.subscriptionService.subscriptionData.subscribe(
			(data: SubscriptionStatus): void => {
				if (data && data.announcements && data.announcements.length) {
					this.announcementData = data.announcements;
					this.actionList = this.announcementData.reduce((total, next) => {
						for (const action of this.subscriptionService.createActionList(
							next.actions
						)) {
							const actionMethod: string = next.actions[action].method;
							if (actionMethod !== 'MANUAL') {
								total.push(action);
							} else if (
								action === 'CHOOSE_PLAN' &&
								actionMethod === 'MANUAL'
							) {
								total.push(action);
							}
						}
						return total;
					}, []);
				} else {
					this.announcementData = null;
				}
			}
		);
	}

	private openAlertModal(alert: AlertAction): void {
		const { message, title } = alert;
		const modal = this.snModalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});

		if (title) {
			modal.componentInstance.title = title;
		}

		modal.componentInstance.text = message;

		modal.componentInstance.buttons = [
			{
				text: 'Got it',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];
	}

	private onConfirmPaymentPaymentOpen(): void {
		this.confirmPaymentOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.confirmPaymentOpen,
			() => {
				this.disableButton = false;
			}
		);
	}

	private onCheckoutOpenEvent(): void {
		this.checkoutPlanOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutOpen,
			() => {
				this.disableButton = false;
			}
		);
	}

	private onEditBillingModalIframeOpen(): void {
		this.billingOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.billingUpdateOpen,
			(): void => {
				this.disableButton = false;
			}
		);
	}

	private onUpdatePaymentClose(): void {
		this.updateOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.updatePaymentOpen,
			(): void => {
				this.disableButton = false;
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.ts